export const ADMIN = 1;

